/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import * as io from 'io-ts';

/**
 * The component version sets item entity type.
 * @export
 */
export type EntityComponentVersionSetsItem = io.TypeOf<typeof ComponentVersionSetsItem>;

/**
 * The component version sets item entity definition.
 * @export
 */
export const ComponentVersionSetsItem = io.type(
  {
    displayName: io.string,
    webPath: io.string,
  },
  `ComponentVersionSetsItem`,
);
